module.exports = __webpack_public_path__ + "static/media/empty_queue_banner.c5238356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty_queue_banner.png
// module id = 839
// module chunks = 0